import React, { useState } from 'react'
import { TermsVersion } from '@repo/domain'


const EXISTING_CLIENT_TEXT = `Informujemy, że wprowadziliśmy Regulamin świadczenia usług, który określa zasady współpracy oraz korzystania z naszej oferty. Akceptacja regulaminu jest konieczna do dalszego świadczenia usług. Z chwilą akceptacji regulaminu kontynuacja korzystania z usług oznacza zawarcie umowy na jego warunkach.`


interface TermsConsentModalProps {
  termsVersion: TermsVersion
  onAccept: () => Promise<void>
  onLogout: () => void
}

export function TermsConsentModal({ termsVersion, onAccept, onLogout }: TermsConsentModalProps) {
  const [checked, setChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const isExisting = termsVersion === TermsVersion.ExistingClient
  const heading = 'Akceptacja regulaminu'
  const text = isExisting ? EXISTING_CLIENT_TEXT : ''

  const handleAccept = async () => {
    if (!checked) return
    setLoading(true)
    try {
      await onAccept()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '2rem',
        maxWidth: '560px',
        width: '100%',
        margin: '1rem',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
      }}>
        <h2 style={{ margin: '0 0 1rem', fontSize: '1.2rem', fontWeight: 600 }}>
          {heading}
        </h2>

        <p style={{ color: '#444', lineHeight: 1.6, whiteSpace: 'pre-line', marginBottom: '1.5rem' }}>
          {text}
        </p>

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1.5rem', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ marginTop: '3px', width: '16px', height: '16px', flexShrink: 0 }}
          />
          <span style={{ color: '#333', fontSize: '0.95rem', lineHeight: 1.5 }}>
          Oświadczam, że zapoznałem się z <a href="https://panel.twopoint.pl/polityka-prywatnosci" target='_blank' style={{ color: 'blue' }}>Polityką Prywatności</a> oraz <a href='https://panel.twopoint.pl/regulamin' target='_blank' style={{ color: 'blue' }}>Regulaminem</a>,  którego treść w pełni akceptuję i zobowiązuję się do jego przestrzegania.
          </span>
        </label>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onLogout}
            style={{
              padding: '0.65rem 1.25rem',
              backgroundColor: 'transparent',
              color: '#666',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '0.95rem',
              cursor: 'pointer',
            }}
          >
            Wyloguj
          </button>

          <button
            type="button"
            onClick={handleAccept}
            disabled={!checked || loading}
            style={{
              padding: '0.65rem 1.5rem',
              backgroundColor: !checked || loading ? '#ccc' : '#000',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.95rem',
              cursor: !checked || loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Zapisywanie...' : 'Akceptuję'}
          </button>
        </div>
      </div>
    </div>
  )
}
